import { initialStateData } from 'shared/state/Base';

import { AppletsSchema } from './Applets.schema';

export const state: AppletsSchema = {
  events: initialStateData,
};
